import React from 'react';
import styled from 'styled-components';
const TagContainer = styled.div`
    border-radius: 25px;
    background-color: ${(props) => props.color};
    width: max-content;
    padding: 0.2rem 1rem;
    color: white;
    font-family: Inter;
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-align: center;

`
const FeedbackListStatusTag = ({ status, color }) => {
    return (
        <TagContainer color={color} className={`status-tag ${status}`}>
            {status}
        </TagContainer>
    );
};

export default FeedbackListStatusTag;
